<template>
  <div id="myfavorites">
    <h3 class="pageheader">Favorite Logs</h3>
    <b-spinner v-if="loading" type="grow" label="Spinning"></b-spinner>
    <LogCards
      v-if="!loading"
      v-bind:logs="logs"
    />
  </div>
</template>

<script>
import LogCards from './LogCards.vue'
import firebase from 'firebase'
import axios from 'axios'
const apiUrl = 'https://logcrow.appspot.com/'
// const apiUrl = 'http://192.168.212.101:9999/'
// const apiUrl = 'http://localhost:9999/'

export default {
  name: 'myfavorites',
  components: {
    LogCards
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    makeToast(variant = null, message) {
      this.$root.$bvToast.toast(message, {
        title: `${variant || 'message'}`,
        variant: variant,
        solid: true
      })
    },
    execSearch() {
      this.loading = true
      this.$store.commit('setLogs', [])
      let currentUser = firebase.auth().currentUser
      if (currentUser) {
        currentUser.getIdToken(true).then(async (idToken) => {
          let res = await axios.get(apiUrl + 'myfavorite', {
            headers: {'Authorization': `Bearer ${idToken}`},
            params: {
              current_page: this.currentPage - 1, // Vue Bootstrap側のPagenationは1から、BackendのAPI側は0からのカウントになるので-1してAPI call
              per_page: 20
            }
          })
          if (res.data.logs) {
            this.$store.commit('setLogs', res.data.logs)
            this.$store.commit('setTotalRows', res.data.hits_count)
            this.$store.commit('setPerPage', 20)
            this.loading = false
          } else {
            this.makeToast('warning', "No logs...")
            this.loading = false
          }
        }).catch(() => {
          this.makeToast('warning', "Failed to get logs...")
          this.loading = false
        })
      }
    },
  },
  computed: {
    logs(){
      return this.$store.getters.logs
    },
    currentPage() {
      return this.$store.getters.currentPage
    }
  },
  watch: {
    currentPage() {
      this.execSearch()
    }
  },
  beforeCreated: function() {
    this.$store.commit('setCurrentPage', 1)
  },
  mounted: function() {
    this.execSearch()
  }
}
</script>

<style>
.pageheader {
    text-align: left;
    margin: 16px;
}
</style>
